/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Breakdown_Kind_Pet_FeeInputs */

const en_price_breakdown_kind_pet_fee = /** @type {(inputs: Price_Breakdown_Kind_Pet_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pet fee`)
};

/**
* | output |
* | --- |
* | "Pet fee" |
*
* @param {Price_Breakdown_Kind_Pet_FeeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_breakdown_kind_pet_fee = /** @type {((inputs?: Price_Breakdown_Kind_Pet_FeeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Breakdown_Kind_Pet_FeeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_breakdown_kind_pet_fee(inputs)
});